import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, createStyles, Theme as AugmentedTheme, FormControlLabel, Radio} from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

interface ISelect {
    field: CustomInputMappingField,
    value: string,
    selectChangeHandler: (val: string) => void,
    setCondition: (val: string) => void,
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    formControl: {
        minWidth: 120,
      },
    iconSize: {
        width: 20,
        height: 20,
    },
    val: {
        fontSize: '14px!important'
    },
    btns: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
    } as CSSProperties,
    btn: {
        width: 'fit-content',
        cursor: 'pointer'
    },
    colorRadio: {
        color: '#979AAA',
        '&.Mui-checked': {
          color: '#7B4FF0',
        },
    },
    label: {
        color: '#202124',
        position: 'static',
        fontSize: 16,
        transform: 'none',
        fontWeight: 400,
        lineHeight: '24px',
        marginBottom: 5,
        letterSpacing: .1,
    } as CSSProperties,
}))

// const 

export default function RadioSelect({ field, value, selectChangeHandler , setCondition,isRtl}: ISelect) {
    const classes = useStyles();

    const [options, setOptions] = useState<string[]>([]);

    const handleChange = (val: string, isSelected: boolean) => {
        const newVal = isSelected ? '' : val

        selectChangeHandler(newVal);
        setCondition(newVal)
    }

    useEffect(() => {
        if(field.options) {
            const selectOptions = field.options?.split(';');
            setOptions(selectOptions);
        }
    }, [field.options])


    return(
        <FormControl className={classes.formControl}>
            <div style={{ 
                    direction: isRtl ? 'rtl' : 'ltr',
                    textAlign: isRtl ? 'right' : 'left' 
            }} className={classes.label}>{field.fieldName}</div>
            <div className={classes.btns} style={{ 
                    direction: isRtl ? 'rtl' : 'ltr',
                    textAlign: isRtl ? 'right' : 'left' 
                }} >
                    {options.map((x, i) => {
                        return <div className={classes.btn} onClick={() => handleChange(x, value === x)}><FormControlLabel checked={value === x} classes={{label: classes.val}} key={x + i} value={x} control={<Radio className={classes.colorRadio} classes={{root: classes.iconSize}} />} label={x} /></div>
                    })}
                </div>
      </FormControl>
    )
}
